export const PAYMENT_REQUEST_HOSTORY_ROUTES = {
  index: {
    path: 'paymentRequestHistory/*',
    to: '/paymentRequestHistory',
  },
  dashboard: {
    path: 'dashboard',
    to: '/paymentRequestHistory/dashboard',
  },
};
